angular.module('unica_track.track_services')

.factory('TrackListService', function ($http, getBaseApiURL) {

	var trackListService = {};

	trackListService.list = function (eventId, limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/track/list/' + eventId,
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.tracks;
			}

		});

	};


	trackListService.fullList = function (eventId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/track/full-list/' + eventId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.tracks;
			}

		});
	};

	trackListService.get = function (trackId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/track/detail/' + trackId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.track;
			}

		});

	};


	return trackListService;
});